import { Injectable } from "@angular/core";
import { firstValueFrom, map, Observable, shareReplay, switchMap } from "rxjs";
import { GetSiteDTO } from "src/app/api/api-types";
import { ApiUrl } from "src/app/api/api-url-helper";
import { RequestService } from "src/app/core/request.service";
import { SiteReference, SitesService } from "src/app/core/sites";
import { getSiteApiUrl } from "src/app/core/sites/site.model";
import { EditSiteModel } from "src/app/partner/shared/edit-site.model";
import { SiteSettings } from "src/app/partner/site-settings/site-settings.model";
import { pluckDistinctUntilChanged } from "src/utils";
import { PartnersService } from "../partners/partners.service";

@Injectable({ providedIn: "root" })
export class SiteSettingsService {
  public constructor(
    private readonly request: RequestService,
    private readonly sites: SitesService,
    private readonly partners: PartnersService,
  ) {}

  public readonly changes = this.sites.selectedChanges.pipe(
    switchMap((site) => this.get(site)),
    shareReplay(1),
  );

  public readonly generalSettingsChanges = this.changes.pipe(
    pluckDistinctUntilChanged("generalSettings"),
  );

  public get(site: SiteReference): Observable<SiteSettings> {
    return this.request
      .get({
        prefix: getSiteApiUrl(site),
        path: ApiUrl.YMS_SITE_SETTINGS,
      })
      .pipe(map((data) => SiteSettings.deserialize(data)));
  }

  public async updateGeneral(
    site: SiteReference,
    body: EditSiteModel,
  ): Promise<GetSiteDTO> {
    const response = await firstValueFrom(
      this.request.put({
        prefix: getSiteApiUrl(site),
        path: ApiUrl.GENERAL_SITE_SETTINGS,
        body: body.serialize(),
      }),
    );

    this.partners.notifyUpdates();

    return response;
  }
}
